import React from "react";
import { useInView } from "react-intersection-observer";
import { format, isThisMinute } from "date-fns";

export default function DoubleColumnList(props) {
  const [slideUpRef, isInView] = useInView({ triggerOnce: true });
  const { title } = props;

  const renderColumns = (items) =>
    items.map((item) => {
      const [slideUpRef, isInView] = useInView({ triggerOnce: true });
      return !props.press ? (
        <div
          key={item.adviser_name}
          ref={slideUpRef}
          className={`col-10 col-md-4 offset-1 animation ${
            isInView ? "logo-slide-up" : ""
          }`}
        >
          <div className="adviser">
            <h3
              className="heading3 adviser__name"
              dangerouslySetInnerHTML={{ __html: item.adviser_name }}
            />
            <h4
              className="heading4 adviser__title"
              dangerouslySetInnerHTML={{ __html: item.adviser_title }}
            />
          </div>
        </div>
      ) : (
        //If has press props

        <div
          key={item.date + item.title.rendered}
          ref={slideUpRef}
          className={`col-sm-12 col-lg-6 animation ${
            isInView ? "logo-slide-up" : ""
          }`}
        >
          <div className="row">
            <div className={`col-12`}>
              <div className={`press-container`}>
                <p className="date">
                  {format(new Date(item.date), "MMMM d, yyyy")}
                </p>
                <p>
                  <a
                    className="press-heading"
                    href={
                      item.content.rendered.match(/href="([^"]+)"/)?.[1] ||
                      item.content.rendered.replace(/(<([^>]+)>)/gi, "").trim()
                    }
                    target="_blank"
                    rel="noopener"
                    dangerouslySetInnerHTML={{ __html: item.title.rendered }}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    });
  return !props.press ? ( //If it doesn't have the press props, return this
    <div className="container-fluid board-advisers">
      <div className="row">
        <div
          ref={slideUpRef}
          className={`col-10 offset-1 $ animation ${
            isInView ? "slide-up" : ""
          }`}
        >
          <h2
            className="heading2"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </div>
      </div>

      <div className="row">{renderColumns(props.content)}</div>
    </div>
  ) : (
    //If it has the press props, return this

    <React.Fragment>
      <section className="col-12 col-lg-10 offset-lg-1">
        <div className="row justify-content-between">
          {renderColumns(props.content)}
        </div>
      </section>
    </React.Fragment>
  );
}
